module.exports = __webpack_public_path__ + "static/media/android_hdpi_line_60.b263c581.png";